import React, {useEffect, useState} from "react";
import {useHistory} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

//components:
import {Field, Form, Formik} from "formik";
import {CircularProgress} from "@material-ui/core";
import CloudIcon from "@material-ui/icons/Cloud";
import TermsAndConditionsChallenge from "./challenges/TermsAndConditionsChallenge";
import Swal from "sweetalert2";

//redux:
import {setInitialState, tryLogin} from "../../redux_slices/authenticationSlice";
import {loadParameter} from "../../redux_slices/contextSlice";
import {sendDataLayer} from "../../util/tagmanager";
import SignUpChallenge from "./challenges/SignUpChallenge";

export default ({redirect = false}) => {
    const {t} = useTranslation();

    const {REACT_APP_BACKEND_API_URL} = process.env;

    let [formDisabled, setFormDisabled] = useState(false);

    const contextSelector = useSelector(state => state.context);
    const contextStatus = useSelector(state => state.context.status);
    const contextChallenges = useSelector(state => state.context.challenges);

    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        if (contextStatus.type === "failed" && contextStatus.error) {
            setFormDisabled(true);
            Swal.fire({
                icon: "error",
                text: t(contextStatus.error),
            }).then(async result => {
                await dispatch(setInitialState());
                setFormDisabled(false);
            });
        }
    }, [contextStatus]);

    let container;
    // if (isAuthenticated && contextStatus.type === "succeeded") {
    if (contextStatus.type === "succeeded") {
        if (contextChallenges && contextChallenges.length) {
            for (let challenge of contextChallenges) {
                switch (challenge.key) {
                    case `termsAndConditions`:
                        container = (
                            <div className="d-flex flex-column-fluid flex-center">
                                <TermsAndConditionsChallenge />
                            </div>
                        );
                        break;
                    case `signUp`:
                        container = (
                            <div className="d-flex flex-column-fluid flex-center">
                                <SignUpChallenge values={challenge.value} />
                            </div>
                        );
                        break;
                }
            }
        } else {
            container = (
                <div className="d-flex flex-column-fluid flex-center flex-column">
                    <CircularProgress />
                    <p className="font-weight-bold font-size-h3 mt-4">
                        {contextStatus.type === "loading"
                            ? `${t("AUTH.LOGIN.LOADING")}...`
                            : `${t("AUTH.LOGIN.SUCCEEDED")}!`}
                    </p>
                </div>
            );
            if (redirect) {
                setTimeout(() => history.push("/"), 2000);
            }
        }
    } else if (contextStatus.type === "loading" && contextChallenges && contextChallenges.length) {
        container = (
            <div className="d-flex flex-column-fluid flex-center">
                <CircularProgress />
            </div>
        );
    } else {
        container = <p>Challenge error</p>;
    }

    return <div className="w-100">{container}</div>;
};
